import React, { useState } from "react";
import styles from "../../../../../../styles/Campaigns/CampaignLogs.module.scss";
import TabView from "../../../../../common/Tabs";
import CampaignDetailsPanel from "../createEvents/CampaignTab";
import MediaDetailsPanel from "../createEvents/MediaTab";
import TargetGroupDetailsPanel from "../createEvents/TargetGroupTab";
import ScreenTab from "../createEvents/ScreenTab";

const CampaignCreate = () => {
  const [selectedTab, setSelectedTab] = useState("campaignDetails");
  const tabs = [
    {
      id: "campaignDetails",
      title: "Campaign",
      panel: (
        <div className={styles.tabContainer}>
          <CampaignDetailsPanel />
        </div>
      ),
    },
  ];

  // Add Target Groups tab if target groups exist

  tabs.push({
    id: "targetGroupDetails",
    title: `Target Group`,
    panel: (
      <div className={styles.tabContainer}>
        <TargetGroupDetailsPanel />
      </div>
    ),
  });

  // Add Theatre and Screens tab
  tabs.push({
    id: "theatreAndScreensDetails",
    title: "Screens",
    panel: (
      <div className={styles.tabContainer}>
        <ScreenTab />
      </div>
    ),
  });

  // Add Media Details tab if medias exist
  tabs.push({
    id: "mediaDetails",
    title: `Media`,
    panel: (
      <div className={styles.tabContainer}>
        <MediaDetailsPanel />
      </div>
    ),
  });

  return (
    <TabView
      id="campaignViewTabs"
      selectedTabId={selectedTab}
      tabs={tabs}
      onChange={(tab) => {
        setSelectedTab(tab);
      }}
    />
  );
};

export default CampaignCreate;
